import React, { useEffect, useState } from 'react'
import { List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { UserRole } from '../models/AccessControl'
import { MenuItemProps } from '../configs/menuItemsConfig'
import { menuItems } from '../configs/menuConfig'

interface LeftPanelProps {
  role: UserRole
}

const PageSelector: React.FC<LeftPanelProps> = ({ role }) => {
  const location = useLocation()
  const [selectedItem, setSelectedItem] = useState(location.pathname)

  useEffect(() => {
    const pathItems = location.pathname.split('/')
    setSelectedItem(`/${pathItems[1]}`)
  }, [location])

  const handleListItemClick = (route: string) => {
    setSelectedItem(route)
  }

  const renderMenuItems = (items: MenuItemProps[]) => {
    return items.map((item) => (
      <React.Fragment key={item.route}>
        <ListItemButton
          component={Link}
          to={item.route}
          selected={selectedItem === item.route}
          onClick={() => handleListItemClick(item.route)}
          sx={{
            borderRadius: '0.4rem',
            backgroundColor:
              selectedItem === item.route ? '#E7E7E7' : 'inherit',
            '&.Mui-selected': {
              backgroundColor: '#E7E7E7',
            },
            '&.Mui-selected:hover': {
              backgroundColor: '#E7E7E7',
            },
          }}
        >
          {item.icon && (
            <ListItemIcon sx={{ minWidth: '2rem' }}>
              <item.icon
                color={selectedItem === item.route ? '#1705E5' : '#97999B'}
              />
            </ListItemIcon>
          )}
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{
              fontSize: '0.82rem',
              color: selectedItem === item.route ? '#04002E' : '#797979',
            }}
          />
        </ListItemButton>
        {/*item.nestedRoutes && renderMenuItems(item.nestedRoutes)*/}
      </React.Fragment>
    ))
  }

  return (
    <List disablePadding component='nav' sx={{ width: '100%' }}>
      {renderMenuItems(menuItems[role.name])}
    </List>
  )
}

export default PageSelector
